"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobSchema = exports.JobHandlerFunction = exports.DailyStreakNotifType = exports.JobsType = exports.PushNotifType = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
exports.PushNotifType = zod_1.z.enum([
    'CUSTOM',
    'CREATE_ACCOUNT',
    'CREATE_ACCOUNT_REMINDER',
    'TRY_FIRST_GAME',
    'TRY_FIRST_GAME_REMINDER',
    'COLLECT_NON_PURCHASE_REWARD',
    'COLLECT_PURCHASE_REWARD',
    'COLLECT_GENERIC_BUNDLED_PURCHASE',
    'PLAY_ACTIVE_OFFER_GAME',
    'PLAY_ACTIVE_OFFER_GAME_REMINDER',
    'MAKE_PURCHASE_IN_ACTIVE_OFFER_GAME',
    'CLAIM_QUEST_REWARD',
    'WEEKLY_QUEST_REFRESH',
    'NEW_FLASH_QUEST_AVAILABLE',
    'DAY_TWO_STARTER_QUEST',
    'PLAY_TEN_MINUTES_QUEST',
    'MAKE_PURCHASE',
    'MAKE_PURCHASE_REMINDER',
    'REWARDS_UNLOCKED',
    'PIGGY_CHEST_AVAILABLE',
    'EARN_UP_TO_NOTIF',
    'CLAIM_PLAYTIME_REWARD',
    'REWARDED_PLAYTIME_OFFER_FINISHED',
    'QUEST_ASSIGNED',
    'MMP_REWARDED_EVENT_EARNED',
    'REWARDED_PLAYTIME_REMINDER',
    'REWARDED_PLAYTIME_REMINDER_END',
    'END_OF_OFFER_REWARDS_REMINDER',
    'EARLY_MMP_REWARDED_EVENT_REMINDER',
    'WEEK_ONE_MMP_REWARDED_EVENT_REMINDER',
    'PLAYTIME_BATCH_FINISHED',
    'PLAYTIME_BATCH_STARTED',
    'OFFER_PROMOTION',
    'REFERRAL_REWARD',
    'STREAK_INCREASE_AVAILABLE',
    'STREAK_CLAIM_1',
    'STREAK_CLAIM_2',
    'STREAK_SAVE_1',
    'STREAK_SAVE_2',
]);
exports.JobsType = zod_1.z.enum([
    'DAILY_TASK_SCAN',
    'PUSH_NOTIFICATION',
    'HISTORY',
    'UPDATE_QUEST',
    'OFFER_PROMOTION',
    'OFFER_PROMOTION_PUSH_NOTIF',
    'FAILED',
]);
exports.DailyStreakNotifType = zod_1.z.enum([
    'STREAK_INCREASE_AVAILABLE',
    'STREAK_CLAIM_1',
    'STREAK_CLAIM_2',
    'STREAK_SAVE_1',
    'STREAK_SAVE_2',
]);
exports.JobHandlerFunction = zod_1.z.enum([
    'tryFirstGame',
    'playActiveOfferGame',
    'playActiveOfferGameReminder',
    'makePurchaseInOffer',
    'makePurchaseReminder',
    'makePurchase',
    'createAccount',
    'claimQuestReward',
    'sendEarnUpToNotif',
    'newQuestAvailable',
    'dayTwoStarterQuest',
    'playTenMinutesQuest',
    'rewardedPlaytimeReminder',
    'rewardedPlaytimeReminderEnd',
    'endOfOfferRewardsReminder',
    'earlyMMPRewardedEventReminder',
    'weekOneMMPRewardedEventReminder',
    'collectNonPurchaseReward',
    'sendNewPlaytimeBatch',
    'sendDailyStreakNotif',
]);
exports.JobSchema = zod_1.z.object({
    FCMToken: zod_1.z.string().optional(),
    aaid: zod_1.z.string().optional(),
    activatedOfferId: zod_1.z.string().optional(),
    appUsageAccess: zod_1.z.boolean().optional(),
    appsflyerId: zod_1.z.string().optional(),
    appInstanceId: zod_1.z.string().optional(),
    createdAt: types_1.FTimestamp,
    data: zod_1.z.any().optional(),
    deviceName: zod_1.z.string().optional(),
    ip: zod_1.z.string(),
    isLimitAdTrackingEnabled: zod_1.z.boolean().optional(),
    manufacturer: zod_1.z.string().optional(),
    metadata: zod_1.z
        .object({
        activatedOfferId: zod_1.z.string().optional(),
        pushNotifType: zod_1.z.string().optional(),
    })
        .optional(),
    model: zod_1.z.string().optional(),
    notifType: zod_1.z.string().optional(),
    notification: zod_1.z.any().optional(),
    offerId: zod_1.z.string().optional(),
    os: zod_1.z.string().optional(),
    osVersion: zod_1.z.string().optional(),
    platform: zod_1.z.string().optional(),
    startTimestamp: types_1.FTimestamp,
    taskHandler: exports.JobHandlerFunction.optional(),
    topic: zod_1.z.string().optional(),
    type: exports.JobsType,
    uniqueId: zod_1.z.string().optional(), // Android only
    userId: zod_1.z.string(),
});
